import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { Provider } from 'react-redux'
import { store } from './store'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './components/auth/MsAuthConfig'

// const msalInstance = new PublicClientApplication(msalConfig)

createRoot(document.getElementById('root')).render(
  // <MsalProvider instance={msalInstance}>
  <Provider store={store}>
    <App />
  </Provider>
  // </MsalProvider>
)
